import React from 'react';
import _isEmpty from 'lodash/isEmpty';
import { getIconName } from './Source.utils';
import OutboundLink from '../../../../../../atoms/OutboundLink/OutboundLink';
import Icon from '../../../../../foundation/components/Icon';
import './Source.css';
var defaultProps = {
  link: ''
};
export default function Source(_ref) {
  var source = _ref.source,
    link = _ref.link;
  var iconName = getIconName(source);
  var isLink = !_isEmpty(link);
  function buildContainer(content) {
    if (isLink) {
      return /*#__PURE__*/React.createElement(OutboundLink, {
        href: link,
        label: iconName
      }, content);
    }
    return content;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "source-container"
  }, buildContainer(/*#__PURE__*/React.createElement(Icon, {
    iconName: iconName,
    link: isLink
  })));
}
Source.defaultProps = defaultProps;